<template>
  <div class="page page-wide" id="page-publishers">
    <Metadata
      :title="this.title"
    />
    <NavLeftBlank />
    <div class="content-wrapper">
      <div class="content" id="content-advertisers">
        <div class="page-heading">
          <h1 class="heading-h1">Inventory Quality Assessment:</h1>
        </div>
        <div id="publisher-wrapper">
          <template v-for="advertiser in advertisers">
            <h2 class="publisher-name">
              {{advertiser.label}}
            </h2>
            <iframe scrolling="no"
              id='iframe_wrapper'
              v-bind:src="advertiser['embed.label']"
              :frameborder=0
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Top from '../components/nav/Top.vue';
import NavLeftBlank from '../components/nav/LeftBlank.vue';
import Bottom from '../components/nav/Bottom.vue';

export default {
  name: 'publishers',
  props: {
    error: String,
  },
  beforeMount() {
    if (this.error) {
      this.$notify({
        group: 'notifications',
        title: 'Not Found',
        text: this.error,
        position: 'bottom right',
        duration: 5000,
        type: 'warn',
      });
    }
  },
  components: {
    Top,
    NavLeftBlank,
    Bottom,
  },
  data() {
    return {
      title: `reporting - publishers`,
      advertisers: this.$store.state.advertisers,
      screen: {
        height: window.innerHeight,
        width: window.innerWidth,
      }
    };
  },
};
</script>

<style>

/* publishers */
.publisher-name {
  font-weight: 600;
  font-size: 25px;
  padding: 0 0 0.4em 0;
}

#publisher-wrapper {
  padding: 45px;
  height: 180%;
}

</style>
